import { cn } from "@/lib/utils";
import { CheckIcon, CircleIcon } from "lucide-react";

export const PermissionCheck = ({
  checked,
  onClick,
  disabled,
}: {
  checked: boolean;
  onClick: (prop: boolean) => void;
  disabled: boolean;
}) => {
  return (
    <div
      onClick={() => {
        if (disabled) {
          return null;
        }
        onClick(!checked);
      }}
      className={cn(disabled ? "opacity-65" : "")}
    >
      {checked ? (
        <CheckIcon className="text-primary" size={17} />
      ) : (
        <CircleIcon className="text-slate-300" size={17} />
      )}
    </div>
  );
};
